import { ChangelogService } from "connection/changelog-service";
import { checkErrorMessage, getErrorMessage } from "./errors";
import { setItemsCount } from "./paginator";

const SET_CHANGE_LOGS = "SET-CHANGE-LOGS";
const SET_CHANGE_LOG = "SET-CHANGE-LOG";
const SET_IS_CHANGE_LOG_UPDATED = "SET-IS-CHANGE-LOG-UPDATED";
const SET_SELECTED_CHANGE_LOG_ITEM = "SET-SELECTED-CHANGE-LOG-ITEM";

let changeLogData = {
    tableHeader: ['#', 'notificationType', "releaseTag", "incidentTime", "CREATED_AT", "UPDATED_AT", "createdBy", "content"],
    controlButtons: ["edit", "delete"],
    changeLogs: null,
    changeLog: {},
    totalElements: 0,
    notificationsTypes: ["NEW_FEATURE", "BUG_FIX", "TECH_WORK", "UX_UI_FEATURE"],
    isChangeLogUpdated: false,
    selectedChangelogItem: null
}

const ChangeLog = (state = changeLogData, action) =>{
    switch(action.type){
        case SET_CHANGE_LOGS:
            let data = action.changeLogs && action.changeLogs.content ? action.changeLogs.content : [];
            let count = action.changeLogs && action.changeLogs.totalElements ? action.changeLogs.totalElements : 0;
            return {...state, changeLogs: data, totalElements: count}
        case SET_CHANGE_LOG:
            let changeLogData = {...state.changeLog}

            if(!changeLogData || changeLogData.id !== action.changeLogId){
                changeLogData = action.changeLog;
            }
            if(action.language === 'ru'){
                changeLogData['content'] = action.changeLog.content;
            }
            else if(action.language === 'en')
                changeLogData['contentEn'] = action.changeLog.content;
            else if(action.language === 'kk')
                changeLogData['contentKk'] = action.changeLog.content;
            
            return {...state, changeLog: changeLogData, selectedChangelogItem: action.changeLogId}
        case SET_IS_CHANGE_LOG_UPDATED:
            return {...state, isChangeLogUpdated: action.isChangeLogUpdated}
        default:
            return {...state};
    }
}

export default ChangeLog;

export const setIsChangelogUpdated = (isChangeLogUpdated) => {
    return {
        type: SET_IS_CHANGE_LOG_UPDATED,
        isChangeLogUpdated: isChangeLogUpdated
    }
}

export const setChangeLogs = (changeLogs) => {
    return {
        type: SET_CHANGE_LOGS,
        changeLogs: changeLogs
    }
}

export const setChangeLog = (changeLogId, changeLog, language) => {
    return {
        type: SET_CHANGE_LOG,
        changeLog: changeLog,
        language: language,
        changeLogId: changeLogId
    }
}

export const getChangeLog = (selectedLanguage, language) => {
    return (dispatch) => {
        ChangelogService.getChangelog(selectedLanguage, language).then(data => {
            dispatch(setChangeLog(data.id, data, language))
            dispatch(setItemsCount(data.totalElements ? data.totalElements : 0))
        }).catch(error => {
            dispatch(checkErrorMessage({code: error.response.status, message: getErrorMessage(error)}))
        });
    }
}

export const getChangeLogs = (selectedLanguage, currentPage = 0, showedItemsCount = 20) => {
    return (dispatch) => {
        ChangelogService.getChangelogs(selectedLanguage, currentPage, showedItemsCount).then(data => {
            dispatch(setChangeLogs(data))
            dispatch(setItemsCount(data.totalElements ? data.totalElements : 0))
            //dispatch(setIsChangelogUpdated(true));
        }).catch(error => {
            dispatch(checkErrorMessage({code: error.response.status, message: getErrorMessage(error)}))
        });
    }
}

const getContentByLanguage = (language) => {
    switch(language){
        case 'RUS':
            return 'content';
        case 'ENG':
            return 'contentEn';
        case 'KAZ':
            return 'contentKk';
    }
}

export const createChangelog = (selectedLanguage, parameters, currentPage, showedItemsCount) => {
    let params = {...parameters};
    return (dispatch) => {
        ChangelogService.createChangelogArticle(selectedLanguage, params).then(data => {
            dispatch(getChangeLogs(selectedLanguage, currentPage, showedItemsCount))

        })
    }
}

export const updateChangelog = (selectedLanguage, changeLogId, parameters, currentPage, showedItemsCount) => {
        let params = {};
        if(parameters.notificationType) params.notificationType = parameters.notificationType;
        if(parameters.content) params.content = parameters.content;
        if(parameters.contentKk) params.contentKk = parameters.contentKk;
        if(parameters.contentEn) params.contentEn = parameters.contentEn;
        if(parameters.incidentTime) params.incidentTime = parameters.incidentTime;
        if(parameters.releaseTag) params.releaseTag = parameters.releaseTag;

    return (dispatch) => {
        ChangelogService.updateChangelog(changeLogId, params).then(data=>{
            dispatch(getChangeLogs(selectedLanguage, currentPage, showedItemsCount));
            dispatch(setIsChangelogUpdated(true));
        }).catch(error => {
            dispatch(checkErrorMessage({code: error.response.status, message: getErrorMessage(error)}));
        });
    }
}

export const deleteChangelog = (selectedLanguage, changeLogId, currentPage, showedItemsCount) => {
    return (dispatch) => {
        ChangelogService.deleteChangelog(changeLogId).then( data => {
            dispatch(getChangeLogs(selectedLanguage, currentPage, showedItemsCount))
        }).catch(error => {
            dispatch(checkErrorMessage({code: error.response.status, message: getErrorMessage(error)}));
        });
    }
}